export default __webpack_public_path__ + "fb54774fd31d678424e0bbeea4fec3a3.svg";